const PROMPT_LABELS: Record<string, string> = {
  'resume-parse': 'Resume Parse',
  'job-parse': 'Job Parse',
  'company-research-overview': 'Company Research Overview',
  'company-research-culture': 'Company Research Culture',
  'company-research-interview': 'Company Research Interview',
  'company-research-news': 'Company Research News',
};

function titleCaseFromId(promptId: string): string {
  return promptId
    .split('-')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function getPerplexityPromptLabel(promptId: string): string {
  return PROMPT_LABELS[promptId] ?? titleCaseFromId(promptId);
}
